export default __webpack_public_path__ + "static/media/H4008.1.035a4be0.mp3";